import { render, staticRenderFns } from "./ArcIcon.vue?vue&type=template&id=4f925efd&"
import script from "./ArcIcon.vue?vue&type=script&lang=js&"
export * from "./ArcIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports